// client/src/api/rag.js
export async function askRag(question, topK = 4) {
  const res = await fetch('/api/rag-chat', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question, topK }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`RAG API error ${res.status}: ${text}`);
  }

  return res.json(); // { answer, sources, usedChunks }
}
